import React from 'react';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';
import styles from './AnalyticsInfo.module.scss';

const AnalyticsCallToAction = ({ action, currentCta, handleOpenCallToActionInfo }) => {
  const myRef = useAccessibleClick(handleOpenCallToActionInfo);

  return (
    <div ref={myRef} tabIndex={0} className={styles.actionWrapper} onClick={handleOpenCallToActionInfo}>
      <div tabIndex={0} className={styles.ctaInfo}>
        <span className={styles.ctaName}>{action.text}</span>
        <span className={styles.ctaLink}>{action.url}</span>
      </div>
      <span tabIndex={0} className={styles.totalViewsAmount}>{currentCta}</span>
    </div>
  )
}

export default AnalyticsCallToAction;